// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"b929567d","456":"03e1a0f7","656":"9036c63a","756":"c8c7584c","968":"736e4683"}[chunkId] + ".chunk.js";
};